import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { AttendContactLateJson } from '@/types/domain/attendContact/entities/attendContactLateEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import LateInfo from '@/domain/attendContact/component/LateInfo';

/**
 * DeleteLateInput
 */
export type DeleteLateInput = {
  /** データ */
  data: AttendContactLateJson | undefined,
  /** 閉じる */
  close: (v: AttendContactLateJson | undefined) => void,
}

const DeleteLate: React.FC<DeleteLateInput> = ({ data, close }) => (
  <Dialog
    open={data !== undefined}
    onClose={() => close(undefined)}
    fullScreen
    TransitionComponent={DialogTransition}
  >
    <DialogTitle title="遅刻連絡" />
    <DialogContent>
      {data && <LateInfo data={data} />}
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => close(data)} color="primary">
        取り消す
      </Button>
      <Button variant="contained" onClick={() => close(undefined)} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteLate;
